export default __webpack_public_path__ + "static/media/heraldofxotlibg.8c145365.jpg";